var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.5,
    height: 138.628,
    viewBox: "0 0 142.5 138.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_22",
    "data-name": "Intersection 22",
    d: "M130.941,138.628a10.588,10.588,0,0,1-7.562-3.1l-21.3-21.3,2.467-2.466-5.624-5.624A60.231,60.231,0,1,1,109.5,94.544l6.128,6.132,2.469-2.469,21.3,21.3a10.606,10.606,0,0,1,3.1,7.836,11.665,11.665,0,0,1-11.282,11.284C131.123,138.628,131.03,138.628,130.941,138.628Zm-23.507-24.34,18.592,18.592a6.859,6.859,0,0,0,5.1,2,7.915,7.915,0,0,0,7.627-7.627,6.892,6.892,0,0,0-2-5.1l-18.59-18.591ZM3.745,60.166A56.421,56.421,0,1,0,60.167,3.745,56.487,56.487,0,0,0,3.745,60.166Zm98.594,43.523,4.915,4.913,5.22-5.218-4.917-4.915ZM11.99,60.166a48.174,48.174,0,1,1,48.177,48.175A48.229,48.229,0,0,1,11.99,60.166Zm3.745,0A44.43,44.43,0,1,0,60.167,15.737,44.479,44.479,0,0,0,15.735,60.166ZM58.293,77.96v-6a11.959,11.959,0,0,1-9.922-9.922h-6a1.873,1.873,0,0,1,0-3.747h6a11.961,11.961,0,0,1,9.922-9.922v-6a1.873,1.873,0,0,1,3.747,0v6a11.966,11.966,0,0,1,9.924,9.922h6a1.873,1.873,0,0,1,0,3.747h-6a11.965,11.965,0,0,1-9.924,9.922v6a1.873,1.873,0,0,1-3.747,0ZM51.952,60.166a8.213,8.213,0,1,0,8.215-8.212A8.224,8.224,0,0,0,51.952,60.166ZM25.439,56.783a1.875,1.875,0,0,1-1.573-2.132,36.687,36.687,0,0,1,31.9-30.916,1.873,1.873,0,1,1,.442,3.72A32.944,32.944,0,0,0,27.566,55.207a1.869,1.869,0,0,1-1.846,1.6A2.232,2.232,0,0,1,25.439,56.783Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.48d6e6f1ccbe17747b47d016c5c5f259.svg";
export { ForwardRef as ReactComponent };